import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {GtmService} from "../service/gtm/gtm.service";

@Component({
  selector: 'app-page-500',
  templateUrl: './page-500.component.html',
  styleUrls: ['./page-500.component.scss']
})
export class Page500Component implements OnInit {

  constructor(private route: ActivatedRoute,
              private gtmService: GtmService) {
    this.gtmService.pageViewWithPage({
      'path': this.route.snapshot['_routerState'].url,
      'title': 'Error 500',
      'breadcrumb': 'Home > 500'
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/page-500/page-500.component.ts